// extracted by mini-css-extract-plugin
export default {"shortcut":"shortcut__3yXkNm_bU9xTEhviZLHWn5","key":"key__7xR57PrHKdZ9ypc_a_CIM"};